import { useRef } from "react";
import "./legend.css";

import { all_protos } from "./protos/all_protos";
import { useMobileContext } from "contexts/MobileContext";
import { useIsTouchDevice } from "hooks/useIsTouchDevice";

export default function Legend({ legendItems, children }) {
  const { isLayerSelectionExpanded, isStatsPanelExpanded } = useMobileContext();

  const isTouchDevice = useIsTouchDevice();
  // Auto-collapse legend when layer selection or stats panel is expanded on mobile
  const isOpen = isTouchDevice
    ? !isLayerSelectionExpanded && !isStatsPanelExpanded
    : true;
  const ref = useRef(null);

  const transformOffset =
    !isOpen && ref.current
      ? { transform: `translateX(${-ref.current.offsetWidth - 5}px)` }
      : {};

  if (legendItems.length === 0) return null;

  return (
    <div
      className={"legend-container" + (isOpen ? " open" : "")}
      style={transformOffset}
    >
      <div className="legend-content shadow-xl" ref={ref}>
        {legendItems.map((x, i) => {
          const Proto = all_protos[x.layer_type];
          return (
            <Proto legend={x} key={x.layer_title}>
              {children}
            </Proto>
          );
        })}
      </div>
    </div>
  );
}
